import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { mobileSideBar, removeUser } from "../../slices/userSlice";
import history from "../../managers/history";
import { useLocation } from "react-router-dom";
import ChangePasswordDialog from "../../modules/dialog/changePasswordDialog";
import UpdateProfile from "../../modules/dialog/updateProfileDialog";

const Header = () => {
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [showUpdateProfile, setShowUpdateProfile] = useState(false);
  const [expandedProfile, setExpandedProfile] = useState(false);
  const [profileImagePreview, setProfileImagePreview] = useState("");
  const location = useLocation();
  const pathNameCheck = location.pathname === "/setup-consent";
  const user = useSelector((state) => state.user);
  const dispatch = new useDispatch();

  useEffect(() => {
    if (!user?.isLoggedIn) return history.push("/");
  }, [user.isLoggedIn]);

  const logOutHandler = () => {
    dispatch(removeUser({}));
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setExpandedProfile(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handleMobileSideBar = () => {
    if (user?.isMobileSidebar) {
      dispatch(mobileSideBar(false));
      return;
    }
    dispatch(mobileSideBar(true));
  };
  const handleUpdateProfile = () => {
    setExpandedProfile((prev) => !prev);
    setShowUpdateProfile(true);
  };

  const handleChangepassword = () => {
    setExpandedProfile((prev) => !prev);
    setShowChangePassword(true);
  };

  return (
    <>
      <div className="flex items-center justify-between px-4 py-15px md:pb-9px md:pl-15px md:pr-7.5 md:pt-2.5">
        <div className="flex">
          <div
            className="mr-13px flex justify-center md:hidden"
            onClick={handleMobileSideBar}
          >
            {!user?.isMobileSidebar ? (
              <img
                className="mt-9px size-15px"
                src="/images/menu.svg"
                alt="Menu"
              />
            ) : (
              <img
                className="mt-9px size-15px"
                src="/images/cross.svg"
                alt="Cross"
              />
            )}
          </div>
          <img
            className="h-35px w-139px md:h-41px md:w-169px"
            alt="logo"
            src="/images/datasent-logo.svg"
          />
        </div>
        <div
          ref={dropdownRef}
          className="relative grid size-35px place-items-center rounded-full border border-grey-D9D9D9 md:size-45px"
        >
          {profileImagePreview || user?.logo ? (
            <img
              onClick={() => setExpandedProfile((prev) => !prev)}
              className="size-33px cursor-pointer rounded-full object-cover md:size-43px"
              src={profileImagePreview ? profileImagePreview : user?.logo}
              alt="profile"
            />
          ) : (
            <div
              onClick={() => setExpandedProfile((prev) => !prev)}
              className={` flex size-35px items-center justify-center rounded-full ${pathNameCheck ? " cursor-not-allowed" : "cursor-pointer"} font-Poppins text-ft24 font-medium text-black-000000 md:size-45px`}
            >
              {user?.name?.charAt(0)}
            </div>
          )}

          {!pathNameCheck && expandedProfile && (
            <div className="absolute right-5px top-7.5 z-30 rounded-xl bg-white shadow-whiteShadow">
              <div className="flex flex-col items-center gap-5px px-5 pb-3 pt-3.5">
                <div className="relative grid size-8.5 place-items-center overflow-hidden rounded-full border border-grey-D9D9D9">
                  {user?.logo ? (
                    <img
                      className="absolute inset-0 size-full object-cover"
                      src={user?.logo}
                      alt="profile"
                    />
                  ) : (
                    <div className="flex size-8.5 items-center justify-center rounded-full font-Poppins text-ft24 font-medium text-black-000000">
                      {user?.name?.charAt(0)}
                    </div>
                  )}
                </div>
                <div className="flex flex-col items-center">
                  <p className="whitespace-nowrap font-MontserratSemiBold text-ft16-19.5 md:text-ft18-27-0.36 ">
                    {user?.name}
                  </p>
                  <p className="whitespace-nowrap font-MontserratSemiBold text-ft13-15.85-0.26 md:text-ft15-22.5-0.3">
                    {user?.email}
                  </p>
                  <p className="whitespace-nowrap font-MontserratMedium text-ft13-15.85-0.26 md:text-ft15-22.5-0.3">
                    {`ID: ${user?._id}`}
                  </p>
                </div>
              </div>
              <div className="border-b-0.5px border-grey-D9D9D9 "></div>
              <div
                onClick={handleUpdateProfile}
                className="cursor-pointer px-3 py-2 font-PoppinsMedium text-ft15-22.5-0.3 text-purple-6C36B0 md:pb-13px md:pl-4.5 md:pt-3"
              >
                Update Profile
              </div>
              <div className="border-b-0.5px border-grey-D9D9D9 "></div>
              <div
                onClick={handleChangepassword}
                className="cursor-pointer px-3 py-2 font-PoppinsMedium text-ft15-22.5-0.3 text-purple-6C36B0 md:pb-13px md:pl-4.5 md:pt-3"
              >
                Change Password
              </div>
              <div className="border-b-0.5px border-grey-D9D9D9 "></div>
              <div
                onClick={logOutHandler}
                className="cursor-pointer px-3 py-2 font-PoppinsMedium text-ft15-22.5-0.3 text-purple-6C36B0 md:pb-13px md:pl-4.5 md:pt-3"
              >
                Log Out
              </div>
            </div>
          )}
        </div>
      </div>
      <hr className="text-grey-E3E3E3" />
      <ChangePasswordDialog
        showChangePassword={showChangePassword}
        setShowChangePassword={setShowChangePassword}
      />
      <UpdateProfile
        showUpdateProfile={showUpdateProfile}
        setShowUpdateProfile={setShowUpdateProfile}
        setProfileImagePreview={setProfileImagePreview}
      />
    </>
  );
};

export default Header;
